import { TextField } from "@mui/material";

export const NumberField = ({
  name,
  value,
  handleChange,
  setError,
  error,
  maxLength,
  placeholder,
}) => {
  return (
    <TextField
      name={name}
      size="small"
      value={value}
      onChange={(e) => {
        const nValue = e.target.value;
        if (/^[0-9]*$/.test(nValue)) {
          console.log(handleChange);
          handleChange({ target: { name, value: nValue } });
          setError(name, undefined); // Clear error if valid input
        } else {
          setError(name, "Only digits are allowed.");
        }
      }}
      placeholder={placeholder}
      sx={{
        width: "100%",
      }}
      error={Boolean(!!error)}
      helperText={error}
      slotProps={{
        htmlInput: {
          maxLength, // Allow max 10 digits
          inputMode: "numeric", // Mobile numeric keyboard
          pattern: "[0-9]*", // Allows only numeric values (works on some mobile devices)
        },
      }}
      type="tel"
    />
  );
};
